import { atom } from "recoil";

export const DataProvinceState = atom({
  key: "DataProvinceState",
  default: [],
});
